(() => {
  const config = Object.assign({
    freeShippingThresholdCents: 0,
    accountUrl: '/account/login',
    locale: document.documentElement.lang || 'en-US'
  }, window.NoorCartConversionConfig || {});

  let renderToken = 0;

  function money(cents, currency = 'USD') {
    return new Intl.NumberFormat(config.locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: cents % 100 === 0 ? 0 : 2
    }).format(cents / 100);
  }

  async function currentCart() {
    if (window.liquidAjaxCart?.cart) return window.liquidAjaxCart.cart;
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  }

  function renderAccount(root) {
    const wrapper = root.querySelector('dialog-wrapper');
    const header = wrapper?.querySelector(':scope > header');
    if (!header || wrapper.querySelector('.nb-cart-account')) return;
    const account = document.createElement('a');
    account.className = 'nb-cart-account';
    account.href = config.accountUrl;
    account.innerHTML = '<span><strong>Sign in</strong> for a faster checkout</span><svg class="nb-cart-arrow" viewBox="0 0 20 20" aria-hidden="true"><path d="M4 10h11M11 6l4 4-4 4"/></svg>';
    header.insertAdjacentElement('afterend', account);
  }

  function renderShipping(cart, cartElement) {
    const threshold = Number(config.freeShippingThresholdCents) || 0;
    cartElement.querySelector('.nb-shipping-meter')?.remove();
    if (!threshold) return;

    const remaining = Math.max(0, threshold - cart.total_price);
    const progress = Math.min(100, Math.max(0, cart.total_price / threshold * 100));
    const meter = document.createElement('section');
    meter.className = 'nb-shipping-meter';
    meter.setAttribute('aria-live', 'polite');
    meter.style.setProperty('--nb-progress', `${progress}%`);
    meter.innerHTML = `
      <p class="nb-shipping-meter__copy">
        <svg class="nb-cart-check" viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="8.25"/><path d="m6.5 10 2.25 2.25 4.75-5"/></svg>
        <span>${remaining ? `You're <strong>${money(remaining, cart.currency)} away</strong> from complimentary shipping` : '<strong>Complimentary shipping unlocked</strong>'}</span>
      </p>
      <div class="nb-shipping-meter__track" aria-hidden="true"><span class="nb-shipping-meter__fill"></span></div>`;
    cartElement.prepend(meter);
  }

  function normalizeItems(cart, cartElement) {
    const title = document.querySelector('#cartBox .headingTitle');
    if (title) title.textContent = `Your bag (${cart.item_count})`;

    cart.items.forEach((item, index) => {
      const line = cartElement.querySelector(`cart-item[item-number="${index + 1}"]`);
      if (!line) return;
      const titleLink = line.querySelector('.meta .title a');
      if (titleLink) titleLink.textContent = item.product_title;
      let variant = line.querySelector('.nb-item-variant');
      if (!variant && item.variant_title && item.variant_title !== 'Default Title') {
        variant = document.createElement('p');
        variant.className = 'nb-item-variant';
        line.querySelector('.meta')?.append(variant);
      }
      if (variant) variant.textContent = item.variant_title;
      const price = line.querySelector(':scope > .price');
      if (price) price.textContent = money(item.final_line_price, cart.currency);
    });
  }

  function renderRecommendations(cart, cartElement, token) {
    cartElement.querySelectorAll('.nb-cart-complete').forEach((block) => block.remove());
    if (token !== renderToken || !cartElement.isConnected) return;
    if (!cartElement.dataset.nbRecsObserved) {
      cartElement.dataset.nbRecsObserved = 'true';
      const observer = new MutationObserver(() => renderRecommendations(cart, cartElement, token));
      observer.observe(cartElement, { childList: true, subtree: true });
    }
    const rail = cartElement.querySelector('.cart-recs');
    if (!rail) return;

    const isMicroneedlingKit = cart.items.some((item) => {
      const handle = item.handle || '';
      return handle.includes('micro-needling') || handle.includes('microneedling') || handle.includes('infusion-system');
    });
    const headingText = isMicroneedlingKit ? 'Add to Your Routine' : 'You May Also Like';
    rail.classList.add('nb-cart-recs');
    const heading = rail.querySelector('h4');
    if (heading && heading.textContent.trim() !== headingText) heading.textContent = headingText;
    let shown = 0;
    rail.querySelectorAll('[data-cart-rec-item]').forEach((item) => {
      const href = item.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
      const recommendationIsKit = href.includes('micro-needling') || href.includes('microneedling') || href.includes('infusion-system');
      const fitsPairing = isMicroneedlingKit || !recommendationIsKit;
      item.hidden = !fitsPairing || shown >= 3;
      if (fitsPairing && shown < 3) {
        shown += 1;
      }
    });
  }

  async function render() {
    const token = ++renderToken;
    const root = document.querySelector('#cartBox');
    const cartElement = root?.querySelector('coretex-cart[empty="false"]');
    if (!root || !cartElement) return;
    try {
      const cart = await currentCart();
      renderAccount(root);
      renderShipping(cart, cartElement);
      normalizeItems(cart, cartElement);
      renderRecommendations(cart, cartElement, token);
    } catch (error) {
      console.warn('[Noor cart] Enhancement skipped:', error);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    render();
  }, { once: true });
  document.addEventListener('liquid-ajax-cart:init', render);
  document.addEventListener('liquid-ajax-cart:request-end', render);
  document.addEventListener('liquid-ajax-cart:queue-end', render);
  document.addEventListener('component-loaded', (event) => {
    if (event.detail?.component === 'coretex-cart') {
      render();
    }
  });
})();
